import { DataGridPremium, GridRowModel, GridToolbar } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { getFetch } from "../../../../../fetch/fetch";
import { dateToDateString } from "../../etc/etcfunctions";
import e from "express";

const PresentationList: React.FC<any> = (props) => {

    const [rows, setRows] = useState<any>([]);
    const [columns, setColumns] = useState<any>([
        {
            field: "kind", headerName: "설명회 종류", width: 150,
        },
        {
            field: "grade", headerName: "학년", width: 100,
        },
        {
            field: "name", headerName: "이름", width: 100,
        },
        {
            field: "phoneNumber", headerName: "전화번호", width: 150,
        },
        {
            field: "marketingList", headerName: "마케팅 경로", width: 250,
        },
        {
            field: "createdAt", headerName: "신청일자", width: 200,
        },
        {
            field: "memo1", headerName: "메모1", width: 100, editable: true,
        },
        {
            field: "memo2", headerName: "메모2", width: 200, editable: true,
        }
    ]);

    const [loading, setLoading] = useState(false);

    const getPresentationList = async () => {

        try {

            const result: any = await getFetch("/dashboard/report/booking/getpresentationlist");

            console.log(result);

            if (result.message === "success") {

                const newRows: any = [];

                result.data.forEach((element: any) => {

                    const oneRow: any = {};
                    oneRow.id = element.id;
                    oneRow.kind = element.location === "first" ? "1차 설명회" : element.location === "second" ? "2차 설명회" : element.location === "third" ? "미정" : "";
                    oneRow.grade = element.select2 === "n" ? "N수생" : "재학생";
                    oneRow.name = element.name;
                    oneRow.phoneNumber = element.telephoneNumber;

                    var marketingList = "";

                    if (element.marketingList) {
                        element.marketingList.forEach((element2: any, index: number) => {
                            marketingList += element2;

                            if (element2 === "기타" && element.marketingEtcText) {
                                marketingList += "(" + element.marketingEtcText + ")";
                            }

                            if (index !== element.marketingList.length - 1) {
                                marketingList += ", ";
                            }
                        });
                    }

                    oneRow.marketingList = marketingList;

                    const date = new Date(element.createdAt);
                    const dateString = dateToDateString(date, true);
                    oneRow.createdAt = dateString;
                    oneRow.memo1 = element.memo1 ? element.memo1 : "";
                    oneRow.memo2 = element.memo2 ? element.memo2 : "";

                    newRows.push(oneRow);
                });

                setRows([...newRows]);

            }

        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => {
        getPresentationList();
    }, []);


    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {

            var field = "";

            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) {
                    field = key;
                }
            }

            const value = newRow[field] ? newRow[field] : null;
            const id = newRow.id;


            if (!field) {
                return newRow;
            }

            if( field !== "memo1" && field !== "memo2") {
                alert("메모1, 메모2만 수정 가능합니다.");
                return newRow;
            }

            if (!id) {
                return newRow;
            }

            const data = {
                value : value ? value : "",
                id,
                field
            }

            console.log(data);


            fetch("https://peetsunbae.com/dashboard/report/booking/postpresentationmemo", {
                method: "POST",
                credentials: "include",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify(data)
            }).then((res: any) => {
                res.json().then((result: any) => {
                    if (result.message === "success") {

                    }
                })
            }).catch((e: any) => {

            });

            return newRow;

        }, []
    );


    const handleProcessRowUpdateError = React.useCallback((error: Error) => {
        alert(error.message);
    }, []);



    return (
        <div>
            <div style={{
                width: "1500px",
                height: "800px"
            }}>
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    density="compact"
                    processRowUpdate={handleEditCommit}
                    onProcessRowUpdateError={handleProcessRowUpdateError}
                    components={{ Toolbar: GridToolbar }}
                />
            </div>
        </div>
    )
}

export default PresentationList;